// src/Header.js
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Image, MainSearch, SearchFilter } from '../../components/componentIndex';
import Logo from '../../assets/images/logo/Logo.svg';
import { Button, ProfilePhoto } from '../../common/commonIndex';
import { useAuthenticationContext } from '../../services/slices/AuthenticationSlicer';
import { Logout } from "../../services/reducers/authenticationReducer";
import { useNavigate } from 'react-router-dom';
import LogoWithBG from '../../assets/images/logo/gutchek_logo_with_bg.svg';
import CloseIcon from '../../assets/images/doctorProfile/close-icon.svg';

const Header = () => {
  let ProfileIcon = 'https://www.dgvaishnavcollege.edu.in/dgvaishnav-c/uploads/2021/01/dummy-profile-pic.jpg';
  const [isSearch, setIsSearch] = useState(false);
  const [isWebApp, setIsWebApp] = useState(true);
  const [isSearchResult, setIsSearchResult] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [profileImg, setProfileImg] = useState(ProfileIcon);
  const [currentUserInfo, setCurrentUserInfo] = useState({});
  const [queryParamData, setQueryParamData] = useState();
  const dropdownRef = useRef(null);
  const { state: data, dispatch } = useAuthenticationContext();
  const navigate = useNavigate();
  const profileRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);

  const currentStep = 0;
  const [state, setState] = useState({
    anywhere: '',
    nextAvailable: null,
    anyInsurance: '',
  });
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleSubmit = () => {
    window.location.href = '/login?' + currentStep;
  }
  const handleLandingPage = () => {
    window.location.href = '/';
  }
  const handleOnChange = (key, value) => {
    setIsSearch(!isSearch);

    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  }
  const queryStringToObject = (queryString) => {
    // Initialize URLSearchParams with the query string
    const params = new URLSearchParams(queryString);
    const queryObject = {};

    // Iterate over all entries in URLSearchParams
    for (let [key, value] of params.entries()) {
      queryObject[key] = value === 'null' || value === '' ? null : value;
    }

    return queryObject;
  };
  useEffect(() => {
    if (window?.location?.search) {
      let queryParamData = null;
      queryParamData = window?.location?.search?.slice(1);
      const queryObject = queryStringToObject(queryParamData);
      setQueryParamData(queryObject);
    }
  }, [window?.location?.search]);

  const handleInactivity = useCallback(() => {
    handleLogOut();
    // Add your function logic here
  }, []);

  useEffect(() => {
    let timer;
    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(handleInactivity, 5 * 60 * 1000); // 20  60  1000 = 20 minutes
    };

    // Set the initial timer
    resetTimer();

    if (typeof window !== "undefined") {
      // Event listeners to reset timer on user activity
      window.addEventListener("mousemove", resetTimer);
      window.addEventListener("keypress", resetTimer);
      window.addEventListener("click", resetTimer);

      // Cleanup function to clear timer and remove listeners
      return () => {
        clearTimeout(timer);
        window.removeEventListener("mousemove", resetTimer);
        window.removeEventListener("keypress", resetTimer);
        window.removeEventListener("click", resetTimer);
      };
    }
  }, [handleInactivity]);

  // Function to handle scroll and toggle components
  useEffect(() => {
    const path = window.location.pathname
    if (path.includes("search-result")) {
      const handleScroll = () => {
        setScrollTop(window.scrollY);
        if (window.scrollY === 0) {
          setIsSearch(false);
        } else {
          setIsSearch(true);
        }
      };

      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, [window?.scrollY]);

  // Call useEffect when location changes
  useEffect(() => {
    // Function to update state based on the current URL
    const handleLocationChange = () => {
      const path = window.location.pathname;
      // const hash = window.location.hash;
      setIsSearchResult(path.includes("search-result"));
      if (!path.includes("search-result")) {
        setIsSearch(false);
      }
      // setIsSearch(path.includes("search-result"));
      if (path.includes("search-result")) {
        const classList = document.getElementsByTagName('header');
        classList[0]?.classList?.add('search-result-header');
      } else {
        const classList = document.getElementsByTagName('header');
        classList[0]?.classList?.remove('search-result-header');
      }
    };
    // Check if user is authorized based on user data
    if (data && data.userData) {
      setIsAuthorized(true);
      const patientProfile = localStorage.getItem('patientProfile');

      const currntUser = data?.userData?.result;
      setCurrentUserInfo(currntUser);
      const userImg = currntUser?.profileSignedUrl && currntUser?.profileSignedUrl !== '' ? currntUser?.profileSignedUrl : patientProfile && patientProfile !== '' ? patientProfile : ProfileIcon;
      setProfileImg(userImg);
    } else {
      setIsAuthorized(false);
      setProfileImg(ProfileIcon);
    }
    // Initial check for when the component mounts
    handleLocationChange();

    // Override pushState and replaceState to trigger a custom event
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function (...args) {
      originalPushState.apply(this, args);
      window.dispatchEvent(new Event('locationchange'));
    };

    window.history.replaceState = function (...args) {
      originalReplaceState.apply(this, args);
      window.dispatchEvent(new Event('locationchange'));
    };

    // Listen for both popstate and custom locationchange events
    window.addEventListener('popstate', handleLocationChange);
    window.addEventListener('locationchange', handleLocationChange);

    return () => {
      // Clean up the event listeners on component unmount
      window.removeEventListener('popstate', handleLocationChange);
      window.removeEventListener('locationchange', handleLocationChange);

      // Restore original pushState and replaceState functions
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);

  const handleLogOut = () => {
    dispatch(Logout());
    if (window.location.pathname === '/landing') {
      navigate("/login");
    } else {
      setTimeout(() => {
        navigate("/landing");
      }, 50);
    }
  }

  useEffect(() => {
    const storedUserData = localStorage.getItem("userData");
    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
      setCurrentUserInfo((prev) => ({
        ...prev,
        first_name: userData?.result?.first_name,
        last_name: userData?.result?.last_name,
      }));
      setProfileImg(userData?.result?.profileSignedUrl && userData?.result?.profileSignedUrl !== '' ? userData?.result?.profileSignedUrl : ProfileIcon);
      if (userData?.result?.profileSignedUrl) {
        setIsAuthorized(true);
      }
    }
  }, [data, window?.location?.href]);

  useEffect(() => {
    // Close dropdown if clicked outside
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Toggle dropdown visibility
  const handleProfileClick = () => {
    setIsDropdownOpen(prevState => !prevState);
  };

  const handleVisits = () => {
    navigate("/visits");
  }
  const handleProfile = () => {
    navigate("/profile");
  }
  const handleAddYourPractice = () => {
    navigate("/self-serive-form");
  }
  const handleUseApp = () => {
    window.location.href = 'https://gutchek.page.link/welcome'; 
    // //'https://play.google.com/store/apps/details?id=com.gutcheck.android&pcampaignid=web_share';
  }
  const handleCloseWebApp = () => {
    setIsWebApp(false);
  }

  return (
    <div>
      { isWebApp &&(
        <div className='top-bar-webapp'>
          <div className='d-flex justify-content-between align-items-center'>
            <div className='justify-content-between'>
              <div onClick={handleCloseWebApp} className='cursor-pointer'>
                <Image imgUrl={CloseIcon} altText="Logo" className={'close-icon'} />
              </div>
              <div className='d-flex align-items-center'>
                <div className="logo cursor-pointer mx-md-3 mx-0 me-2 ms-1 " onClick={handleLandingPage}>
                  <Image imgUrl={LogoWithBG} altText="Logo" className={'logo-webapp '} />
                </div>
                <div className='app-name'>
                  <h4>Get the app</h4>
                  <p>Book a colonoscopy in minutes</p>
                </div>
              </div>
            </div>
            <Button
              btnClass={'login-btn btn-use-app'}
              btnName={'USE APP'}
              btnType={'button'}
              onClick={handleUseApp}
              isDisabled={true}
            />
          </div>
        </div>
      )}
      <header className={`header text-center ${scrollTop > 0 || isSearch ? 'scrolled' : ''}`}>
        <div className='justify-content-between'>
          <div className="logo cursor-pointer" onClick={handleLandingPage}>
            <Image imgUrl={Logo} altText="Logo" />
          </div>
          {!isSearch && isSearchResult && (
            <SearchFilter onChange={handleOnChange} isSearch={isSearch} setIsSearch={setIsSearch} queryParamData={queryParamData} className={`search-filter-animate ${isSearch ? 'hide' : ''}`} />
          )}
          <div className={`justify-content-center user-profile-name ${isAuthorized ? '' : 'header-right-side'}`}>
            {!isAuthorized ? (
              <>
                <span className='add-your-practice' onClick={handleAddYourPractice}>Add your practice</span>
                <Button
                  btnClass={'login-btn'}
                  btnName={'Log in'}
                  btnType={'button'}
                  onClick={handleSubmit}
                  isDisabled={true}
                />
              </>

            ) : (
              <>
                {/* <span className='add-your-practice' onClick={handleAddYourPractice}>Add your practice</span> */}
                <span className='user-name'>{currentUserInfo?.first_name && currentUserInfo?.last_name ? currentUserInfo?.first_name + ' ' + currentUserInfo?.last_name : ''}</span>
                <div className='position-relative'>
                  <div onClick={handleProfileClick} ref={profileRef}>
                    <ProfilePhoto imgUrl={profileImg} altText={'profile'} className={'user-profile-img cursor-pointer'} />
                  </div>

                  {/* Conditionally render dropdown menu */}
                  {isDropdownOpen && (
                    <div className="dropdown-menu" ref={dropdownRef}>
                      <ul>
                        <li>
                          <Button
                            btnClass={'logout-btn text-link'}
                            btnName={'Profile'}
                            btnType={'button'}
                            onClick={handleProfile}
                            isDisabled={true}
                          />
                        </li>
                        <li>
                          <Button
                            btnClass={'logout-btn text-link'}
                            btnName={'Visits'}
                            btnType={'button'}
                            onClick={handleVisits}
                            isDisabled={true}
                          />
                        </li>
                        <li>
                          <Button
                            btnClass={'logout-btn'}
                            btnName={'Log Out'}
                            btnType={'button'}
                            onClick={handleLogOut}
                            isDisabled={true}
                          />
                        </li>
                        {/* Add more items as needed */}
                      </ul>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        {isSearch && isSearchResult && (
          <div className={`search-padding dashboard-search `}>
            <MainSearch isHeader={true} queryParamData={queryParamData} className={`main-search-animate ${!isSearch ? 'hide' : ''}`} />
          </div>
        )}
      </header>
    </div>

  );
};

export default Header;
